export const draggableThreadId = 'draggable-thread-';
export const emailFolderDroppableId = 'email-folder-droppable-';
